import { AppState } from '../bootstrap';

export class CatalogAppState extends AppState {
  getState() {
    super.getState();

    const selectedBrands = this.raw_data.selectedBrands || [];
    this.selectedBrands = new Map(selectedBrands.map((brand) => (
      [brand.id, brand]
    )));

    this.eventLabel = this.raw_data.EventLabel;
    this.sizeGroupId = this.raw_data.config.sizeGroupId;
    this.isCityModalOpen = false;
    this.userCity = this.userCity ? {
      value: this.userCity.id,
      label: this.userCity.name,
    } : null;
    this.brandSearchText = '';

    const { brand, ...filterData } = this.FilterData;

    this.FilterData = {
      ...filterData,
      brand: {
        topBrands: brand.top_brands,
        brands: brand.brands,
        popularBrands: [],
      },
    };

    return this;
  }
}

export class AsideListAppState extends AppState {
  getState() {
    super.getState();

    const selectedBrands = this.raw_data.selectedBrands || [];
    this.selectedBrands = new Map(selectedBrands.map((brand) => (
      [brand.id, brand]
    )));

    this.eventLabel = this.raw_data.EventLabel;
    this.sizeGroupId = this.raw_data.config.sizeGroupId;
    this.isCityModalOpen = false;
    this.userCity = this.userCity ? {
      value: this.userCity.id,
      label: this.userCity.name,
    } : null;

    return this;
  }
}

export class ToggleFavouriteButtonAppState extends AppState {
  getState() {
    // NOTE. Don't call super.getState(); on the models that coexist
    // with other models on the same page. In that case each model
    // will receive whole JSON payload from backend
    this.config = this.raw_data.config;
    this.url = this.raw_data.toggleFavouriteButtonData.url;
    return this;
  }
}
